import { useTranslation } from "react-i18next";
import { Layout } from "antd";
import { FunctionComponent, useState } from "react";
import PageHeader from "../../../../components/page-header/PageHeader";
import { useLocation } from "react-router-dom";
import AdministrativeUnitDetail from "../../../../components/category-management/management-detail/administrative-unit-info/administrative-unit-detail/AdministrativeUnitDetail";
import "./administrative-unit-management-detail.scss";

const { Content } = Layout;
const imgPath = "/images/";

const AdministrativeUnitManagementDetail: FunctionComponent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [loadingDetail, setLoadingDetail] = useState<boolean>(false);
  const listBreadcrumb = [
    {
      title: t("Quản lý danh mục", "Quản lý danh mục"),
    },
    {
      title: t("Quản lý khác", "Quản lý khác"),
    },
    {
      title: location.state?.tab === "1" ?
            t("Đơn vị cấp Tỉnh", "Đơn vị cấp Tỉnh") : location.state?.tab === "2" ? t("Đơn vị cấp Huyện", "Đơn vị cấp Huyện") : t("Đơn vị cấp Xã", "Đơn vị cấp Xã"),
    },
    {
      title: <span className="style-title">{location.state.name}</span>,
    },
  ];

  return (
    <>
      <Content>
        <PageHeader
          title={location.state?.name ? location.state?.name : ""}
          listBreadcrumb={listBreadcrumb}
          arrowLeft={imgPath + "arrowLeft.svg"}
          positionItem="column"
          breadcrumb={true}
        />
        <div className="tabs-heading">
          <AdministrativeUnitDetail
            administrativeUnitDetail={location.state.record}
            loadingDetail={loadingDetail}
            textRendered={location.state?.textRendered}
            tab={location.state?.tab}
          />
        </div>
      </Content>
    </>
  );
};

export default AdministrativeUnitManagementDetail;
